var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Dialog",
    {
      directives: [
        {
          name: "observe-keyboard",
          rawName: "v-observe-keyboard.l2.enter",
          value: _vm.onConsentGiven,
          expression: "onConsentGiven",
          modifiers: { l2: true, enter: true },
        },
      ],
      class: { branded: _vm.isBranded },
      attrs: {
        heading: _vm.$t("recording_consent_modal.title"),
        "min-width": 500,
        "hide-actions": "",
        closeButton: false,
        "data-cy": "recording-consent-modal",
        scrimClickAction: "",
        escapeKeyAction: "",
      },
    },
    [
      _c(
        "div",
        {
          staticClass: "unselectable recording-consent-modal-content",
          attrs: { slot: "content" },
          slot: "content",
        },
        [
          _c(
            "div",
            { staticClass: "recording-consent-modal-description-wrapper" },
            [
              _c(
                "div",
                { staticClass: "recording-consent-modal-description" },
                [
                  _vm._v(
                    " " +
                      _vm._s(_vm.$t("recording_consent_modal.description")) +
                      " "
                  ),
                ]
              ),
              _c(
                "div",
                { staticClass: "recording-consent-modal-more-details" },
                [
                  _vm._v(
                    " " +
                      _vm._s(_vm.$t("recording_consent_modal.more_details")) +
                      " "
                  ),
                  _c(
                    "a",
                    {
                      attrs: {
                        rel: "noopener noreferrer",
                        target: "_blank",
                        href: "https://www.vonage.com/legal/privacy-policy",
                      },
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.$t("recording_consent_modal.privacy_policy"))
                      ),
                    ]
                  ),
                  _vm._v(". "),
                ]
              ),
            ]
          ),
        ]
      ),
      _c(
        "div",
        {
          staticClass: "footer-buttons",
          attrs: { slot: "footer-buttons" },
          slot: "footer-buttons",
        },
        [
          _c("EndMeetingButton", {
            attrs: {
              shouldCloseWindow: _vm.shouldCloseWindow,
              "data-cy": "recording-consent-leave-meeting-btn",
              label: _vm.leaveBtnText,
              endForAll: _vm.isSessionOwner,
            },
          }),
          _c("vwc-button", {
            attrs: {
              label: _vm.agreeBtnText,
              layout: "filled",
              "data-cy": "recording-consent-agree-btn",
              connotation: "cta",
              appearance: "outlined-light",
            },
            on: { click: _vm.onConsentGiven },
          }),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }